export const NOT_AVAILABLE = 'not available'

const trackEvent = (event: Record<string, unknown>, allow?: boolean): void => {
  if (!window) return
  window.dataLayer = window.dataLayer || []
  ;(typeof allow === 'undefined' || allow) && window.dataLayer.push(event)
}

export default trackEvent
